import axios from 'axios'
// import { BaseServiceProvider } from './BaseServiceProvider'
import urlJoin from 'url-join'
import { PartsBasketCreds, TokensFromAPI } from '../api/security/interfaces'

class TokenServiceProvider {
  getTokens = (creds: PartsBasketCreds): Promise<TokensFromAPI> => {
    return axios
      .post<TokensFromAPI>(
        urlJoin(import.meta.env.VITE_API_BASE_OP_URL, 'token', '1.1', 'token'),
        creds,
        {
          // baseURL: this.getConstructedUrl(),
          headers: {
            'x-token-api-key': import.meta.env.VITE_TOKEN_API_KEY,
          },
        }
      )
      .then((resp) => resp?.data)
  }
}

export default new TokenServiceProvider()
